import {Injectable} from '@angular/core';
import {Offer} from './../models/offer';
import {Device} from './../models/device';
import {Category} from './../models/category';
import {IspPricingModel} from '../models/IspPricing.model';
import {InternetOptionModel} from '../models/InternetOption.model';
import { PPhostedPricing } from '../models/PPhostedPricing.model';
import {ThreeCXPricing} from '../models/ThreeCXPricing';
import {MicrosoftTeamsPricing} from '../models/MicrosoftTeamsPricing';
import {PeoplefoneBundlePricing} from '../models/PeoplefoneBundlePricing';
import {MitelHostedModel} from '../models/MitelHosted.model';

@Injectable()
export class DataStorageService {
  categories: Category[];
  categoriesGlobal: Category[];
  currentLanguage: string;
  currentState: Offer;
  devices: Device[];
  newOfferOpened: boolean;
  editMode: boolean;
  editedDevice: Device;
  devicePopup: boolean;
  devicePricePopup: number;
  success: boolean;
  successMyDev: boolean;
  refreshInProgress: boolean;
  invalidCredentials: string;
  vatValue: number;
  from: 'EDIT' | 'ADD' | null;
  currentCategoryId: number;
  currentCategoryName: string;

  ispPricingIPWORLDCOM: IspPricingModel[];
  addressIPWORLDCOM: InternetOptionModel[];
  slaIPWORLDCOM: InternetOptionModel[];
  typeOfRouterIPWORLDCOM: InternetOptionModel[];

  ispPricingCYBERLINK: IspPricingModel[];
  addressCYBERLINK: InternetOptionModel[];
  slaCYBERLINK: InternetOptionModel[];
  endtoend: InternetOptionModel[];
  mobileFallback: InternetOptionModel[];
  typeOfRouterCYBERLINK: InternetOptionModel[];
  supportTimeCYBERLINK: InternetOptionModel[];

  nodesPricingPPhosted: PPhostedPricing[];

  flatRateHostedPricing: FlatRatePricingModel[];
  flatRateSipTrunkPricing: FlatRatePricingModel[];
  threeCXPricing: ThreeCXPricing[];
  teamsPricing: MicrosoftTeamsPricing[];
  bundlePricing: PeoplefoneBundlePricing[];

  mistelHosted_hosted: MitelHostedModel[];
  mistelHosted_cloundLink: MitelHostedModel[];
  mistelHosted_teleworked: MitelHostedModel[];
  mistelHosted_OipCti: MitelHostedModel[];
  mistelHosted_VpnLink: MitelHostedModel[];
  uiText: KeyValuePair[];
  disclaimeerOn: boolean;

  currentComponent: number;
  sideBarAccordion:
    {offer: boolean,
     edit: boolean,
     management: boolean};


  constructor() {
    this.disclaimeerOn = false;
    this.uiText = [];
    this.from = null;
    this.currentLanguage = 'de';
    this.currentState = new Offer();
    this.currentComponent = 0;
    this.categories = [];
    this.categoriesGlobal = [];
    this.devices = [];
    this.newOfferOpened = false;
    this.editMode = true;
    this.editedDevice = new Device();
    this.devicePopup = false;
    this.devicePricePopup = -1;
    this.success = false;
    this.successMyDev = false;
    this.refreshInProgress = false;
    this.invalidCredentials = '';
    this.sideBarAccordion = {
      offer: true,
      edit: false,
      management: false
    };
    this.currentCategoryId = null;
    this.currentCategoryName = '';
  }

  filterUIText(key: string): string {
    const filtered = this.uiText.filter( e => e.key === key)[0];
    if (filtered === undefined) {
      return '';
    }
    return filtered.value;
  }

  setUIText(key: string, value: string) {
    const filtered = this.uiText.filter( e => e.key === key)[0];
    filtered.value = value;
  }


  clean() {
    this.uiText = [];
    this.currentLanguage = 'de';
    this.currentState = new Offer();
    this.currentComponent = 0;
    this.categories = [];
    this.devices = [];
    this.newOfferOpened = false;
    this.editMode = true;
    this.editedDevice = new Device();
    this.devicePopup = false;
    this.devicePricePopup = -1;
    this.success = false;
    this.successMyDev = false;
    this.refreshInProgress = false;
    this.invalidCredentials = '';
    this.ispPricingIPWORLDCOM = undefined;
    this.addressIPWORLDCOM = undefined;
    this.slaIPWORLDCOM = undefined;
    this.typeOfRouterIPWORLDCOM = undefined;
    this.nodesPricingPPhosted = undefined;
    this.ispPricingCYBERLINK = undefined;
    this.addressCYBERLINK = undefined;
    this.slaCYBERLINK = undefined;
    this.typeOfRouterCYBERLINK = undefined;
    this.supportTimeCYBERLINK = undefined;
    this.endtoend = undefined;
    this.mobileFallback = undefined;
    this.from = null;
    this.threeCXPricing = undefined;
    this.teamsPricing = undefined;
    this.bundlePricing = undefined;
    this.mistelHosted_hosted = undefined;
    this.mistelHosted_cloundLink = undefined;
    this.mistelHosted_teleworked = undefined;
    this.mistelHosted_OipCti = undefined;
    this.mistelHosted_VpnLink = undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/data-storage.service.ts